import React, { Component } from 'react';
import './index.css';
import hamburger from './images/hamburger.svg';
import { itemData } from './ItemData';


var headerLinks = [
    
    {
      title: "Home",
      url: "#",
      current: "false"
    },
    {
      title: "Shop",
      url: "#",
      current: "true"
    },
    {
      title: "Events",
      url: "#",
      current: "false"
    },
    {
      title: "Lessons",
      url: "#",
      current: "false"
    }
];





export class Header extends Component {


  render () {

    var { cartCount } = this.props;
    console.log(cartCount());
  
    
    return (
      <div>


      <div id="big-search">
        <input type="text" placeholder="Search items here" aria-describedby="exampleHelpText" id="big-search-input" autocomplete="off"></input>
      </div>



      <div id="mainheader">

      <div id="header-upper">
        <div id="header-upper-right">
            <a href="#" className="hu-account-name">hi, Tiana Reynolds</a>
            <a href="#" className="hu-my-account">My Account</a>
            <a href="#"className="hu-signout">Sign Out</a>
            <a href="#" className="hu-help">Help</a>
        </div>

        <div className="header-upper-content">

          <div className="hu-login">

            <div className="hu-signin-h-box hu-content-element">
              <h1 className="hu-signin-h">Sign In</h1>
            </div>

            <div className="hu-inputs">
            <input type="text" placeholder="Email/Username" aria-describedby="exampleHelpText" className="hu-login-input hu-login-input1 hu-content-element" />
            <input type="text" placeholder="Password" aria-describedby="exampleHelpText" className="hu-login-input hu-login-input2 hu-content-element" />
            </div>

            <div className="hu-signin-button hu-content-element">Enter  ▸</div>

          </div>
            

        </div>
      </div>


      <div id="header-nav">

        <div id="nav-title">
          <h4>Benheiser Sounds</h4>
        </div>

        <div id="nav-right">

          <div id="nav-links">
            <a id="deburger"><img src={hamburger}/></a>
            {
            headerLinks.map((link) => {
                
                var linkClassList = "navLink";
                if (link.current === "true") {
                    linkClassList = linkClassList + " curLink";
                };

                return (
                <a href={link.url} className={linkClassList}>{link.title}</a>
                );
              }) 
            }
          </div>

          <div id="nav-search2">
            <form>
              <input type="text" placeholder="Search" aria-describedby="exampleHelpText"></input>
            </form>
          </div>

          <div id="nav-search">
            <div id="nav-search-icon">
              <img src="images/search.svg" />
            </div>
            <h4>Search</h4>
          </div>

          

          <div id="nav-cart" title="No functionality...yet">
            <div id="nav-cart-icon">
              <img src="images/cart.svg" />
            </div>
            <div id="nav-cart-count">{cartCount()}</div>
            <h4>Your Cart</h4>
          </div>

          <div id="header-cart-box">
          
          <div className="cart-header">
            
            <h3>Your Cart Items</h3>
            <div className="cart-box-x">✕</div>
            <input type="text" placeholder="Search your cart" className="cart-search"/>
            

          </div>
          
          <div id="header-cart-list">
          <div id="search-item-count-box">
            <div id="search-item-count">{this.props.cartCount()} items in cart</div>
          </div> 
            {
              this.props.carted.map((thisItem) => {

                var searchCartClasses = "search-item-button search-item-cart" + ((thisItem.carted === true) ? " search-cart-clicked" : "");
                var searchHeartClasses = "search-item-button search-item-heart" + ((thisItem.favorited === true) ? " search-heart-clicked" : "");

                return (
                    <a><div className="cartedItemElement" key={thisItem}>
                    <div className={searchCartClasses} onClick={() => {cartCount(); thisItem.carted = false;}}></div>
                    <div className={searchHeartClasses}></div>
          
                    <div className="itemSearchElementIconBlock">
                    <img className="itemPrevImg" src={thisItem.imgURL} alt="Image" />
                    </div>
                    <div className="itemDataBlock">
                    <h5 className="itemName">{thisItem.name}</h5>
                    <h5 className="searchlist-item-manu">by <span>{thisItem.manufacturer}</span></h5>
                    <h5 className="searchlist-item-price">from <span>{thisItem.cost.price}</span></h5>
                    </div>
                    </div></a>
                )
              }) 
            }

          <div id="cart-box-footer">
              <h4>End of Cart List</h4>
          </div>
           
          </div>

          
            

          </div>


        </div> 

      </div> 
      

      </div>
      </div> 
    ) // return
    
  } // render
};







// WEBPACK FOOTER //
// ./src/Header.js